import { useQuery } from "@tanstack/react-query";
import { loadDashboard } from "../api/reportApi";

export function useReportCore(jobId, status) {

    return useQuery({
        queryKey: ["report-core", jobId, status],

        enabled: !!jobId &&
            ["DONE", "ANALYSIS_DONE", "COMPLETED"].includes(status),

        queryFn: async () => {
            const data = await loadDashboard(jobId);

            console.log("DASHBOARD:", data);

            return data;
        },

        retry: 3,
        retryDelay: 1000,
    });
}